import { render, staticRenderFns } from "./WidgetArticles.vue?vue&type=template&id=1c06712d"
import script from "./WidgetArticles.vue?vue&type=script&lang=js"
export * from "./WidgetArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports